 import VFUSerViewer from "./VFUserViewer";
import {connect} from "react-redux";
import { getUser, resetUserList } from "../../../../redux/actions/userManagement/userViewer.action";
import { getPredefinedRoles } from "../../../../redux/actions/userManagement/functionalRoles.action";
import { updateUserPermissions } from "../../../../redux/actions/userManagement/updatePermissions.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import { SubmitActiveInactive } from "../../../../redux/actions/userManagement/userActiveInavtive.action";
import { NotificationOptions, ReadNotification } from "../../../../redux/actions/notification/getEventNotificationList.action";
import { getModuleNotification } from "../../../../redux/actions/notification/getModuleNotification.action";
import { getAllVFusersList } from "../../../../redux/actions/userManagement/getAllVFUserslist.action";
import { resetColumnFilters, setColumnFilters } from "../../../../redux/actions/filters/filter.action";

const mapStateToProps = (state) => {
    return {
        userList:state.userViewer.data,
        isLoading:state.userViewer.isLoading,
        next:state.userViewer.next,
        count:state.userViewer.totalItems,
        functionalRoles:state.functionalRoles.roles,
        VFuserNames:state.onboardingRequest.getAllVFusersList.data,
        myRights:state.myRights.myRights,
        notificationdata:state?.notifications?.moduleNotification?.data?.data?.VF_INTERNAL_USERS,
        columnFilters: state?.filtersReducer?.columnFilters?.VFUSER || {},  
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUser: (type,custID,searchKey,next=null,userNames="",roles="",sort="") => {
            return dispatch(getUser(type,custID,searchKey,next,userNames,roles,sort))
        },
        getPredefinedRoles: (filter) => {
            return dispatch(getPredefinedRoles(filter))
        },
        updateUserPermissions: (payload,id) => {
            return dispatch(updateUserPermissions(payload,id))
        },
        openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
        },
        resetUserList:()=>{
            return dispatch(resetUserList())
        },
        SubmitActiveInactive:(payload,id)=>{
            return dispatch(SubmitActiveInactive(payload,id))
        },
        ReadNotification: (payload,id) => {
            return dispatch(ReadNotification(payload,id))
        },
        getModuleNotification: (moduleName) => {
            return dispatch(getModuleNotification(moduleName))
        },
        NotificationOptions: (payload,id) => {
            return dispatch(NotificationOptions(payload,id))
          },
        getAllVFusersList: () => {
            return dispatch(getAllVFusersList())
        },
        ReadNotification: (payload,id) => {
            return dispatch(ReadNotification(payload,id))
        },
        setColumnFilters: (screen, columnKey, options) =>{
            return dispatch(setColumnFilters(screen, columnKey, options))
        },
        resetColumnFilters: (screen) => {
            return dispatch(resetColumnFilters(screen))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VFUSerViewer);

